import { FC } from 'react';
import MarketplaceCart from '../transaction-cart/marketplace-cart/MarketplaceCart';

const GuestMarketplaceCart: FC = () => {
  return <MarketplaceCart guestMode />;
};

export default GuestMarketplaceCart;
